/**
 * English: Load device-type AI personalities for the ChatTest grid (static map from agent-chat).
 * Thai: โหลดบุคลิก AI ตาม device_type สำหรับ grid ใน ChatTest (static จาก agent-chat)
 */
import { useState, useEffect, useCallback } from 'react';
import { useApi } from './useApi';
import { ENDPOINTS } from '../config/api';

interface UseDevicesResult {
  devices: Record<string, unknown>;
  deviceTypes: string[];
  loading: boolean;
  refresh: () => Promise<void>;
}

export function useDevices(): UseDevicesResult {
  const { get } = useApi();
  const [devices, setDevices] = useState<Record<string, unknown>>({});
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const data = await get(ENDPOINTS.devicePersonalities) as { devices?: Record<string, unknown> };
      setDevices(data.devices || {});
    } catch (err) {
      console.error('Failed to load devices:', err);
    } finally {
      setLoading(false);
    }
  }, [get]);

  useEffect(() => { refresh(); }, [refresh]);

  return { devices, deviceTypes: Object.keys(devices), loading, refresh };
}
